/**
 * Normalize ids from API JSON (string, EJSON { $oid }, etc.) for URLs and path params.
 */
export function normalizeApiEntityId(raw: unknown): string {
  if (raw == null) return '';
  if (typeof raw === 'string') return raw.trim();
  if (typeof raw === 'object' && raw !== null && '$oid' in raw) {
    const oid = (raw as { $oid?: unknown }).$oid;
    if (typeof oid === 'string') return oid.trim();
  }
  return String(raw).trim();
}
